import { RouteRecordRaw } from 'vue-router';
import { HomologationRecordPage } from '@/pages/homologation';

export const routeName = 'HomologacaoRegistro';

export const route: RouteRecordRaw = {
  path: 'homologacao/registro/:id',
  name: routeName,
  component: HomologationRecordPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Registro',
    permissions: [
      { action: 'manageApproval', subject: 'Homologation' },
      { action: 'manageVerification', subject: 'Homologation' },
      { action: 'send', subject: 'Document' },
      { action: 'manage', subject: 'RecordManagement' },
    ],
    matchMode: 'any',
  },
};
